import { format } from 'date-fns';

import { getDateFnsLocale } from './calendarLocaleMap';

/** Localized date (numeric style varies by locale). */
export const INTERVIEW_SLOT_DATE_PATTERN = 'P';

/** Localized time — 12h vs 24h and meridiem follow locale defaults. */
export const INTERVIEW_SLOT_TIME_PATTERN = 'p';

const toDate = (value: Date | string | number): Date =>
  value instanceof Date ? value : new Date(value);

export const formatInterviewSlotDateForDisplay = (
  value: Date | string | number,
  appLocale: string
): string =>
  format(toDate(value), INTERVIEW_SLOT_DATE_PATTERN, {
    locale: getDateFnsLocale(appLocale)
  });

export const formatInterviewSlotTimeForDisplay = (
  value: Date | string | number,
  appLocale: string
): string =>
  format(toDate(value), INTERVIEW_SLOT_TIME_PATTERN, {
    locale: getDateFnsLocale(appLocale)
  });
